import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { getCookie } from "../utils/cookies";
import Button from "../components/Button";

const SubscribeSuccess: React.FC = () => {
  const [sessionId, setSessionId] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const sid = searchParams.get("session_id");
    setSessionId(sid);
    (async () => {
      if (!sid) {
        setLoading(false);
        return;
      }
      try {
        const base =
          process.env.REACT_APP_API_URL || "http://localhost:5000/api";
        const token = getCookie("toddlar_token");
        // Optional debug fetch, include auth if present
        await fetch(
          `${base}/billing/checkout-session?session_id=${encodeURIComponent(
            sid
          )}`,
          {
            headers: {
              ...(token ? { Authorization: `Bearer ${token}` } : {}),
            },
          }
        ).catch(() => {});
        // Failsafe: confirm subscription state on server
        await fetch(`${base}/billing/confirm-checkout`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            ...(token ? { Authorization: `Bearer ${token}` } : {}),
          },
          body: JSON.stringify({ session_id: sid }),
        }).catch(() => {});
      } catch (e) {
        // ignore
      } finally {
        setLoading(false);
      }
    })();
  }, [searchParams]);

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4">
      <div className="max-w-xl w-full bg-white rounded-lg shadow p-8 text-center">
        <div className="text-6xl mb-4">🎉</div>
        <h1 className="text-3xl font-bold mb-2">Subscription active!</h1>
        <p className="text-gray-600 mb-6">
          Thank you for subscribing. You will receive 800 points after payment
          succeeds (usually instant in test mode). You can now use your points
          to order toys.
        </p>
        <div className="flex gap-3 justify-center">
          <Button
            onClick={() => navigate("/browse")}
            size="large"
            variant="primary"
          >
            Browse toys
          </Button>
        </div>
      </div>
    </div>
  );
};

export default SubscribeSuccess;
